import React, { useState } from 'react';

// Round colour swatch button shared by the compression and braces catalogues.
export function ColourSwatch({
  color,
  colorHex,
  swatchImage,
  selected,
  onClick,
  size = 'sm',
}: {
  color: string;
  colorHex: string;
  swatchImage?: string;
  selected: boolean;
  onClick: () => void;
  size?: 'sm' | 'lg';
}) {
  const [imgError, setImgError] = useState(false);
  const dim = size === 'lg' ? 'w-10 h-10' : 'w-7 h-7';

  return (
    <button
      title={color}
      onClick={onClick}
      className={`${dim} rounded-full transition-all border-2 overflow-hidden ${
        selected
          ? 'ring-2 ring-offset-2 ring-[#7B68CC] scale-110 border-white'
          : 'border-white hover:scale-105 hover:ring-2 hover:ring-offset-1 hover:ring-gray-300'
      } shadow-sm`}
    >
      {swatchImage && !imgError ? (
        <img
          src={swatchImage}
          alt={color}
          className="w-full h-full object-cover rounded-full"
          onError={() => setImgError(true)}
        />
      ) : (
        <div className="w-full h-full rounded-full" style={{ backgroundColor: colorHex }} />
      )}
    </button>
  );
}
